import { render, staticRenderFns } from "./FornecedorDetalhesHeader.vue?vue&type=template&id=4e2e12b6"
import script from "./FornecedorDetalhesHeader.vue?vue&type=script&lang=js"
export * from "./FornecedorDetalhesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports